module.exports = __webpack_public_path__ + "static/media/encore.4798dbf9.gif";